import { useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, ListTodo, Store, MessageSquare } from "lucide-react";

const NAV_ITEMS = [
  { path: "/", icon: LayoutDashboard, label: "Home" },
  { path: "/tasks", icon: ListTodo, label: "Tasks" },
  { path: "/stores", icon: Store, label: "Stores" },
];

export default function MobileBottomNav({ onChatClick }) {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav 
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-stone-200 md:hidden safe-area-bottom"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {NAV_ITEMS.map(item => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 transition-colors ${
                active ? "text-stone-900" : "text-stone-400"
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? "stroke-[2.5]" : ""}`} />
              <span className={`text-[10px] font-medium ${active ? "text-stone-900" : "text-stone-500"}`}>
                {item.label}
              </span>
            </button>
          );
        })}
        {/* Chat button */}
        <button
          data-testid="mobile-nav-chat"
          onClick={onChatClick}
          className="flex flex-col items-center justify-center flex-1 h-full gap-0.5 text-stone-400 transition-colors"
        >
          <div className="relative">
            <MessageSquare className="w-5 h-5" />
            <span className="absolute -top-1 -right-1 w-2 h-2 bg-emerald-500 rounded-full"></span>
          </div>
          <span className="text-[10px] font-medium text-stone-500">AI Chat</span>
        </button>
      </div>
    </nav>
  );
}
